import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const Privacy = () => (
    <div className="max-w-3xl mx-auto space-y-6 text-elegant text-sm leading-relaxed" data-testid="privacy-page">
        <Link to="/dashboard" className="inline-flex items-center gap-2 text-brand hover:underline text-sm">
            <ArrowLeft className="w-4 h-4" /> Torna alla dashboard
        </Link>
        <div>
            <div className="text-xs uppercase tracking-[0.3em] text-brand mb-2">Informativa</div>
            <h1 className="font-display text-4xl font-bold text-warm flex items-center gap-3">
                <ShieldCheck className="w-9 h-9 text-brand" /> Privacy Policy
            </h1>
            <div className="text-xs text-elegant mt-2">Ultimo aggiornamento: 8 maggio 2026</div>
        </div>

        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">1. Titolare del trattamento</h2>
            <p>
                <strong className="text-warm">MAKAI di Maria Laura Pellino</strong><br />
                P.IVA 09936410969<br />
                Email: privacy@smarttable.it
            </p>
        </section>

        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">2. Dati raccolti</h2>
            <p>Smart Table tratta i seguenti dati personali per fornire il servizio gestionale:</p>
            <ul className="list-disc pl-6 space-y-1">
                <li><strong className="text-warm">Account ristoratore</strong>: email, nome, ruolo, ID Google (in caso di accesso OAuth).</li>
                <li><strong className="text-warm">Personale</strong>: email, nome utente per credenziali camerieri/cucina/cassa.</li>
                <li><strong className="text-warm">Clienti del ristorante</strong>: nome, telefono, email, allergie, note prenotazione (se inserite manualmente o ricevute da Prenova).</li>
                <li><strong className="text-warm">Dati di servizio</strong>: ordini, pagamenti, scontrini, fatture (compresi codice fiscale e P.IVA per fatturazione).</li>
                <li><strong className="text-warm">Cookie tecnici</strong>: sessione, autenticazione (no profilazione).</li>
            </ul>
        </section>

        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">3. Base giuridica e finalità</h2>
            <ul className="list-disc pl-6 space-y-1">
                <li><strong className="text-warm">Esecuzione del contratto</strong> (art. 6.1.b GDPR): erogazione del servizio gestionale.</li>
                <li><strong className="text-warm">Obbligo di legge</strong> (art. 6.1.c GDPR): conservazione dati fiscali (10 anni come da normativa).</li>
                <li><strong className="text-warm">Consenso</strong> (art. 6.1.a GDPR): per cookie non essenziali (raccolto via banner).</li>
            </ul>
        </section>

        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">4. Diritti dell'interessato</h2>
            <p>Hai diritto di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione (artt. 15-21 GDPR). Per esercitarli scrivi a privacy@smarttable.it. Hai inoltre il diritto di proporre reclamo al Garante Privacy.</p>
        </section>

        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">5. Trasferimento dati</h2>
            <p>I dati sono ospitati su server localizzati nell'UE. Non avviene trasferimento extra-UE. I dati di pagamento sono gestiti da Stripe (privacy.stripe.com). I dati AI per Insights sono elaborati da Anthropic Claude in conformità al loro DPA.</p>
        </section>

        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">6. Conservazione</h2>
            <p>Account: per la durata del contratto + 24 mesi. Dati fiscali: 10 anni. Cookie tecnici: durata sessione.</p>
        </section>
    </div>
);

export default Privacy;
